import { Box, Button } from '@nimbus-ds/components';
import { InitialScreen } from '@nimbus-ds/patterns';
import classNames from 'classnames';
import useNavegate from 'App/hooks/useNavegate';
import { IonPageStratus } from 'commons/components/IonPageStratus';
import { useResponsive } from 'commons/components/Responsive';
import { DRAFT_ORDERS_ROUTES } from 'domains/Orders/DraftOrders/draftOrdersRoutes';
import useTranslationOrders from 'domains/Orders/useTranslationOrders';
import {
  SectionAppCard,
  SectionAppCardDomains,
} from 'domains/PartnersApps/components';
import emptyDraftOrders from './empty-draft-orders.png';
import DraftOrdersHelpLink from '../DraftOrdersHelpLink/DraftOrdersHelpLink';
import './DraftOrdersListEmpty.scss';

function DraftOrdersListEmpty(): JSX.Element {
  const t = useTranslationOrders();
  const { goTo } = useNavegate();
  const { isMobile } = useResponsive();

  const onClickAddOrder = () => {
    goTo(DRAFT_ORDERS_ROUTES.newDraftOrder);
  };

  const className = classNames('stratus--draft-orders-list-empty-text-color', {
    'stratus--draft-orders-list-empty-center-text': isMobile,
  });

  return (
    <IonPageStratus width="medium">
      <InitialScreen>
        <div className={className}>
          <InitialScreen.Hero
            subtitle={t('draftOrders.title').toUpperCase()}
            title={t('draftOrders.empty.title')}
            description={
              <>
                {t('draftOrders.empty.description.line1')}
                <br />
                {t('draftOrders.empty.description.line2')}
              </>
            }
            image={
              <img
                src={emptyDraftOrders}
                alt={t('draftOrders.title')}
                height={isMobile ? '198px' : '100%'}
                width={isMobile ? '198px' : '100%'}
              />
            }
            actions={
              <Button onClick={onClickAddOrder} appearance="primary">
                {t('draftOrders.empty.action')}
              </Button>
            }
          >
            <Box marginTop="6">
              <SectionAppCard
                source={DRAFT_ORDERS_ROUTES.draftOrderList}
                appCategory="accounting"
                domain={SectionAppCardDomains.DRAFT_ORDERS}
              />
            </Box>
          </InitialScreen.Hero>
        </div>
        <Box
          display="flex"
          flexDirection="row"
          gap="2"
          justifyContent="center"
          mt="5"
          paddingTop="5"
        >
          <DraftOrdersHelpLink />
        </Box>
      </InitialScreen>
    </IonPageStratus>
  );
}

export default DraftOrdersListEmpty;
